import type { PortalViewOutput } from '@garage/shared';
import { PhoneIcon } from '../../ui/icons.js';
import { telHref } from './GarageContact.js';
import { PortalQuestions } from './PortalQuestions.js';
import { Block } from './portal-ui.js';

/**
 * Onglet Messages : le fil avec le garage (messages, photos dans les deux sens, liens sûrs, cartes
 * d'événement) et le formulaire pour écrire. Une question n'est jamais une décision sur des travaux.
 */
export function MessagesTab({ view }: { view: PortalViewOutput }) {
  const { garage } = view;
  return (
    <Block title="Échanges avec le garage" id="echanges">
      <p className="mb-3 text-base text-ink-2">
        Écrivez à {garage.displayName} à tout moment : une question, une précision, une photo. La réponse arrive ici et par e-mail.
      </p>
      <PortalQuestions messages={view.messages} garageName={garage.displayName} />
      {garage.phone ? (
        <p className="mt-4 text-center text-base text-ink-2">
          Vous préférez appeler ?{' '}
          <a href={telHref(garage.phone)} className="inline-flex min-h-(--ctl-sm) items-center gap-1.5 font-medium text-ink underline underline-offset-2">
            <PhoneIcon size={18} /> {garage.phone}
          </a>
        </p>
      ) : null}
    </Block>
  );
}
